export { default } from './gtm';
